import { FilePlus2, RefreshCw, StickyNote, Bell, Mail, UserCheck, MessageSquareText } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const ICON = { created: [FilePlus2, "text-emerald"], status: [RefreshCw, "text-sky-300"], note: [StickyNote, "text-orange-300"], alert: [Bell, "text-amber-300"], reminder: [Mail, "text-violet-300"], assign: [UserCheck, "text-emerald-300"], sms: [MessageSquareText, "text-pink-300"] };

const fmt = (iso) => new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export const LeadTimeline = ({ lead, onClose }) => {
  const items = Array.isArray(lead?.activity) && lead.activity.length
    ? [...lead.activity].reverse()
    : lead ? [{ at: lead.created_at, type: "created", text: "Application submitted", by: lead.name }] : [];

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto border-white/10 bg-card text-white">
        <DialogHeader>
          <DialogTitle>Activity · {lead?.name} <span className="ml-1 font-mono text-xs text-orange-300">{lead?.ref}</span></DialogTitle>
        </DialogHeader>
        <ol className="relative mt-2 space-y-5 border-l border-white/10 pl-6" data-testid="lead-timeline">
          {items.map((a, i) => {
            const [I, c] = ICON[a.type] ?? ICON.status;
            return (
              <li key={i} className="relative" data-testid={`timeline-item-${i}`}>
                <span className="absolute -left-[35px] flex h-6 w-6 items-center justify-center rounded-full border border-white/10 bg-ink"><I size={12} className={c} /></span>
                <p className="text-sm text-slate-100">{a.text}</p>
                <p className="mt-0.5 text-xs text-slate-400">{fmt(a.at)} · {a.by}</p>
              </li>
            );
          })}
        </ol>
      </DialogContent>
    </Dialog>
  );
};
